import {
  FixedTable as SharedFixedTable,
  FixedTableProps as SharedFixedTableProps,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type FixedTableProps<TData extends { id: string }> = Omit<
  SharedFixedTableProps<TData>,
  "footer"
> & {
  /** 'virtualized' = fixed height + internal scroll (default); 'inline' = natural height + parent scroll */
  mode?: "virtualized" | "inline";
};

export function FixedTable<TData extends { id: string }>({
  noRowsText,
  ...props
}: FixedTableProps<TData>) {
  const t = useT();
  return (
    <SharedFixedTable
      {...props}
      noRowsText={noRowsText ?? t("general.table.empty")}
      footer={{
        height: 48,
        languageTexts: {
          item: t("component.table.fixed.item"),
          items: t("component.table.fixed.items"),
        },
      }}
    />
  );
}
